import { ApiError } from '@minisoc/api-client';
import { Button, Logo, Spinner } from '@minisoc/ui';
import { useState, type FormEvent } from 'react';
import { useAuth } from './AuthProvider';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setPending(true);

    try {
      await login(email, password);
    } catch (cause) {
      // Message volontairement générique, y compris quand l'API précise la
      // cause : distinguer « compte inconnu » de « mot de passe incorrect »
      // permettrait d'énumérer les comptes existants.
      setError(
        cause instanceof ApiError && cause.status !== 401
          ? cause.message
          : 'Identifiants invalides.',
      );
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-void px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex justify-center">
          <Logo className="h-10" />
        </div>

        <form onSubmit={submit} className="card space-y-4 p-6">
          <div>
            <h1 className="text-lg font-semibold text-text">Accès à votre dashboard</h1>
            <p className="mt-1 text-sm text-text-muted">
              Surveillance de la sécurité de votre infrastructure.
            </p>
          </div>

          <label className="block">
            <span className="label-caps">Adresse email</span>
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="mt-1.5 w-full rounded-lg border border-border-strong bg-surface-sunken px-3 py-2.5 text-sm text-text outline-none focus:border-brand-500"
            />
          </label>

          <label className="block">
            <span className="label-caps">Mot de passe</span>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="mt-1.5 w-full rounded-lg border border-border-strong bg-surface-sunken px-3 py-2.5 text-sm text-text outline-none focus:border-brand-500"
            />
          </label>

          {error ? (
            <p role="alert" className="rounded-lg bg-critical/10 px-3 py-2 text-sm text-critical">
              {error}
            </p>
          ) : null}

          <Button type="submit" variant="primary" block disabled={pending}>
            {pending ? <Spinner /> : null}
            {pending ? 'Connexion…' : 'Se connecter'}
          </Button>
        </form>

        <p className="mt-4 text-center text-xs text-text-dim">
          Accès réservé. Toute tentative de connexion est journalisée.
        </p>
      </div>
    </div>
  );
}
